const initialState = {
  loading: false,
  user: null,
  loggedIn: false,
  invalidLogin: false,
  initialCheck: false,
  error: null,
}

export default initialState;